import React, { Component } from 'react';

/** Core */
import InputDate from '../../../core/InputDate';
import Label from '../../../core/Label';
import Buttons from '../../../core/Buttons';
import WrapperControl from '../../../core/WrapperControl';
import DropdownInput from '../../../core/DropdownInput';

/** Styles */
import { StyledSearchFormControl } from './style';

class SearchFormControl extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dateFrom: null,
      dateTo: null,
      station: null
    };
  }

  onSearch = () => {
    const { onSearch } = this.props;
    const { dateFrom, dateTo, station } = this.state;
    onSearch({ station, dateFrom, dateTo });
  };

  handlerDrop = e => {
    this.setState({ station: e.value });
  };

  render() {
    const { options } = this.props;
    return (
      <StyledSearchFormControl>
        <WrapperControl className="wrapper-control">
          <Label label="Emisora" className="mb-5" />
          <DropdownInput
            label="Seleccionar"
            className="drop-station"
            list={options}
            onSelect={this.handlerDrop}
          />
        </WrapperControl>
        <WrapperControl className="wrapper-control">
          <Label label="Fecha desde" className="mb-5" />
          <InputDate onChange={e => this.setState({ dateFrom: e })} />
        </WrapperControl>
        <WrapperControl className="wrapper-control">
          <Label label="Fecha hasta" className="mb-5" />
          <InputDate onChange={e => this.setState({ dateTo: e })} />
        </WrapperControl>
        <div className="wrapper-btn-send wrapper-control">
          <Buttons className="btn-send" dark onClick={this.onSearch}>
            Buscar
          </Buttons>
        </div>
      </StyledSearchFormControl>
    );
  }
}

export default SearchFormControl;
